import { Time } from 'phaser';
import Tapper from '../../../tapper/Tapper';

const TICK_RATE = 100;

export default class Autoclick extends Phaser.GameObjects.Sprite {
    private timer: Time.TimerEvent | null = null;
    private enabled: boolean;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, 'atlas', 'icons/cheat_autoclick');

        this.enabled = false;

        this.setInteractive({ useHandCursor: true });
        this.on('pointerdown', this.onClick, this);

        this.disable();
    }

    onClick() {
        this.enabled = !this.enabled;

        if (this.enabled) {
            this.enable();
        } else {
            this.disable();
        }
    }

    enable() {
        this.timer = this.scene.time.addEvent({
            delay: TICK_RATE,
            callback: () => this.scene.events.emit(Tapper.EVENTS.TAP),
            repeat: -1,
        });
        this.setAlpha(1);
    }

    disable() {
        this.timer?.remove();
        this.setAlpha(0.5);
    }

    destroy() {
        this.timer?.remove();
        super.destroy();
    }
}
